<template>
  <loading-overlay v-if="loading" class="animated fadeIn" />

  <div v-else class="animated fadeIn">
    <default-heading :text="`Sample Result Analyte: ${sample_result_history.sample_result.analyte}`" class="mt-3">
      <template #right>
        <b-button
          variant="primary"
          class="ml-1 text-white"
          :to="`/results/${$route.params.id}`"
        >
          <i class="fal fa-vials" />
        </b-button>
      </template>
    </default-heading>

    <div class="mt-3" />
    
    <b-card-group class="mb-3">
      <b-card>
        <ResultAnalyteHistoryChart
          v-if="sample_result_history"
          :chartData="chartData"
        />
      </b-card>
    </b-card-group>
  </div>
</template>

<script>
import LoadingOverlay from '@/components/shared/LoadingOverlay'
import DefaultHeading from '@/components/shared/DefaultHeading'
import SampleResultModel from '@/models/result/SampleResultModel'
import ResultAnalyteHistoryChart from '@/components/modus/result/ResultAnalyteHistoryChart'

export default {
  name: 'ResultAnalyteHistory',
  components: {
    LoadingOverlay,
    DefaultHeading,
    ResultAnalyteHistoryChart
  },
  data () {
    return {
      loading: true,
      sample_result_id: this.$route.params.sample_result_id || null,
      sample_result_history: null,
      colors: [
        "#007bff",
        "#6c757d",
        "#28a745",
        "#dc3545",
        "#ffc107", 
        "#17a2b8",
        "#FF6384",
        "#333333",
        "#6f42c1",
        "#e83e8c"
      ],
    }
  },
  mounted () {
    this.fetchSampleResult()
  },
  computed: {
    chartData() {
      const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']

      const datasets = this.sample_result_history.data_sources.map((source, index) => ({
        label: source.label,
        backgroundColor: this.colors[index % this.colors.length],
        borderColor: this.colors[index % this.colors.length],
        fill: false,
        data: source.data_points.map(point => {
          const monthIndex = new Date(point.date).getMonth()

          return {
            x: months[monthIndex],
            y: point.value,
          };
        }),
      }));

      return {
        labels: months,
        datasets,
      }
    }
  },
  methods: {
    fetchSampleResult () {
      const sample_result = new SampleResultModel({ id: this.sample_result_id })

      return sample_result.getHistory().then(({ response }) => {
        if (response && response.status === 200 && response.data) {
          const { data } = response.data
          this.sample_result_history = data
        }

        this.loading = false
      })
    }
  }
}
</script>
